export { default as AlmacenesInventario } from "./AlmacenesInventario";
